<div class="carousel-container" *ngIf="images">

    <div class="carousel" id="carousel">
        <ng-container *ngFor="let image of images; let i = index;">
            <div class="item-container"
                [class.hidden]="i !== activeImage && !(ciclingImages && (i === activeImage + 1 || i === 0 && activeImage === images.length - 1))"
                [class.bounce-out-left]="ciclingImages && i === activeImage && i !== images.length - 1"
                [class.bounce-out-right]="ciclingImages && i === activeImage && i === images.length - 1"
                [class.bounce-in-right]="ciclingImages && i === activeImage + 1"
                [class.bounce-in-left]="ciclingImages && i === 0 && activeImage === images.length - 1"
                [ngStyle]="{'background-image': 'url(' + image.url + ')', 'animation-duration': animationTime + 'ms'}"
            ></div>
        </ng-container>
    </div>

    <div class="caption">
        <ng-container *ngFor="let image of images; let i = index;">
            <p
                [innerHtml]="image.caption"
                [class.hidden]="i !== activeCaption"
                [class.fade-out]="ciclingCaptions && i === activeCaption"
                [class.fade-in]="ciclingCaptions && i === activeCaption + 1"
                [class.small]="smallCaption"
            ></p>
        </ng-container>
    </div>

    <div class="bullets" *ngIf="images.length > 1">
        <ng-container *ngFor="let image of images; let i = index;">
            <div
                class="bullet"
                [class.active]="i === activeItem"
            ></div>
        </ng-container>
    </div>
</div>
